/**
 * 运行时判断当前是否在 Electron 桌面端。
 * Electron preload 脚本会向渲染进程注入 window.electronAPI，
 * 普通浏览器环境中该属性不存在。
 */
export const isElectron: boolean =
  typeof window !== 'undefined' && !!window.electronAPI;
